module.exports = __webpack_public_path__ + "static/media/1230_Music_Top40_HL.5297d7ad.png";